module.exports = __webpack_public_path__ + "static/media/checkScope_5.b5e1950c.png";